module.exports = __webpack_public_path__ + "img/vip-bg-app.5d823958.png";